import Axios from "@app/api/axios";

import { PROMO_CODES } from "@utils/constant";

const getPromoCodesList = (params) => {
  return Axios.get(`${PROMO_CODES}${params}`).then((response) => response.data);
};

export default getPromoCodesList;
